import React, { useState, useEffect } from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { onAuthStateChanged } from "firebase/auth";
import { auth } from '../firebase';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Button, 
  Container, 
  Box,
  Chip,
  Menu,
  MenuItem
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LockIcon from '@mui/icons-material/Lock';

function MainLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [adminUser, setAdminUser] = useState(null);
  const [adminMenuAnchor, setAdminMenuAnchor] = useState(null);
  
  // Check if logged in with admin Google account
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setAdminUser(firebaseUser);
    });
    return unsubscribe;
  }, []);
  
  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  
  const handleAdminMenuOpen = (event) => {
    setAdminMenuAnchor(event.currentTarget);
  };
  
  const handleAdminMenuClose = () => {
    setAdminMenuAnchor(null);
  };

  return (
    <>
      <AppBar position="static" sx={{ mb: 3 }}>
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Challenge App
          </Typography>
          
          <Button 
            component={Link} 
            to="/challenges" 
            color="inherit" 
            startIcon={<HomeIcon />}
            sx={{ mr: 2 }}
          >
            Challenges
          </Button>
          
          {user && (
            <Chip 
              label={`Logged in as: ${user.username}`}
              color="secondary" 
              size="small"
              sx={{ mr: 2 }}
            />
          )}
          
          {/* Admin menu button - only show if Firebase user is authenticated */}
          {adminUser && (
            <>
              <Button
                color="inherit"
                startIcon={<MoreVertIcon />}
                onClick={handleAdminMenuOpen}
                sx={{ mr: 1 }}
              >
                Admin
              </Button>
              <Menu
                anchorEl={adminMenuAnchor}
                open={Boolean(adminMenuAnchor)}
                onClose={handleAdminMenuClose}
              >
                <MenuItem onClick={() => {navigate('/admin'); handleAdminMenuClose();}}>
                  <DashboardIcon fontSize="small" sx={{ mr: 1 }} />
                  Leaderboard
                </MenuItem>
                <MenuItem onClick={() => {navigate('/edit'); handleAdminMenuClose();}}>
                  <EditIcon fontSize="small" sx={{ mr: 1 }} />
                  Edit Challenges
                </MenuItem>
                <MenuItem onClick={() => {navigate('/users'); handleAdminMenuClose();}}>
                  <LockIcon fontSize="small" sx={{ mr: 1 }} />
                  Manage Logins
                </MenuItem>
              </Menu>
            </>
          )}
          
          <Button 
            color="error" 
            variant="contained" 
            size="small"
            startIcon={<LogoutIcon />}
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Toolbar>
      </AppBar>
      
      <Container maxWidth="md">
        <Box sx={{ my: 4 }}>
          <Outlet />
        </Box>
      </Container>
    </>
  );
}

export default MainLayout;
